import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import { UserProvider } from './contexts/UserContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminProtectedRoute from './components/auth/AdminProtectedRoute';
import HomePage from './pages/HomePage';
import AccessDeniedPage from './pages/AccessDeniedPage';
import Theme from './theme';
import './App.css';
import ApplicationUnassignedPage from './pages/ApplicationUnassignedPage';
import Heap from "./services/Heap3E";

declare global {
  interface Window {
    heap: any;
  }
}

function App() {
 const heapAppId = process.env.REACT_APP_HEAP_APP_ID || "974980988";

  Heap.initialize(heapAppId);

  return (
    <ThemeProvider theme={Theme}>
      <CssBaseline />
      <AuthProvider>
        <UserProvider>
          <Router>
            <div className="App">
              <Routes>
                {/* Protected routes */}
                <Route
                  path="/"
                  element={
                    <AdminProtectedRoute>
                      <HomePage />
                    </AdminProtectedRoute>
                  }
                />

                {/* Handle login callback - AuthContext will process it automatically */}
                <Route
                  path="/authentication/login-callback"
                  element={
                    <ProtectedRoute>
                      <HomePage />
                    </ProtectedRoute>
                  }
                />

                              {/* Access Denied page */}
                              <Route path="/access-denied" element={<AccessDeniedPage />} />

                              {/* Access Denied page */}
                              <Route path="/unassigned" element={<ApplicationUnassignedPage />} />

                              {/* Redirect any unknown routes to home */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </Router>
        </UserProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
